import React from 'react';
import ModalInfo from '../../components/ModalInfo';
import './index.scss';

export default function PickupServiceModal(props) {
  const { showModal, onHide } = props;
  return (
    <ModalInfo
      className="pickup-service-modal"
      showModal={showModal}
      onHide={onHide}
      title="上门取送车 Q&A"
    >
      <div className="qa-content-list">
        <div className="qa-sub-title">同城专人上门取/送车到店维修或保养，足不出户，即可解决车辆维修保养</div>
        <div className="qa-item">
          <div className="question-title">Q1：取车和还车怎么使用?</div>
          <div className="answer-content">
            <p>A：取车(从客户预约地点到服务中心)，可通过小鹏APP"预约维保"流程中选择"取送车服务"，输入"取车地点"和"取车时间"、"服务中心"，提交预约即可。</p>
            <p>还车(从服务中心到客户指定地点)，需通过客户车辆维保的服务中心进行发起还车流程，您无需在APP内再发起。请与服务中心联系即可，告知服务中心需求时间及取车地点。</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q2：在使用上门取送车时，是否有额外的费用?</div>
          <div className="answer-content">
            <p>A：一般无任何额外的费用，但由于路程较远的订单，上门取送车可能会产生高速公路费用，此部分费用需要自理。如不愿意走高速，需与代驾司机提前沟通确认，司机会选择走国道，但取送车时间会相对较长。另外在司机取车前已产生的停车费等费用需要自行承担。</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q3：发起了上门取送车，因其他原因需要更改/取消但无法取消，怎么办?</div>
          <div className="answer-content">
            <p>A：通常只要没有司机接单的取送车订单或已有司机接单但还没开始出发的订单，都可以通过直接取消预约来取消取送车订单。如出现如下情况或需求，需联系预约服务中心进行操作:</p>
            <p>1.司机已经出发的订单无法通过APP取消。</p>
            <p>2.仅需要取消取送车订单，但需要保留预约。</p>
            <p>3.临时需要更改时间及取车地点的订单，需要取消原订单重新下单。</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q4：在上门取送车服务期间，出现任何交通事故，应该如何处理?</div>
          <div className="answer-content">
            <p>A：取送车服务期间，车辆发生的有责交通事故由服务商负责处理，不适用车辆自有保险进行理赔，不影响次年保险费用。如获悉车辆发生交通事故，请尽快联系服务中心，由服务专员进行跟踪处理。</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q5：上门取送车服务是否支持跨城市使用?</div>
          <div className="answer-content">
            <p>A：暂不支持，上门取送车服务仅支持起始地点及目的地在同一地级市(或直辖市)的行政范围内。</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q6：使用上门取送车服务时，是否可以中途取消?</div>
          <div className="answer-content">
            <p>A：如果服务专员已接单但未接车时可免费取消服务，如服务专员已将车辆取走后再取消，则无法取消(扣减本次服务次数)</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q7：如果没有预约服务中心，能否使用上门取送车?</div>
          <div className="answer-content">
            <p>A：上门取送车订单必须与服务中心预约进行绑定，所以如果没有预约服务中心，则无法使用上门取送车。客户可直接联系服务中心，由服务专员协助进行服务中心预约及发起上门取送车订单。</p>
          </div>
        </div>
        <div className="qa-item">
          <div className="question-title">Q8：如何知道取送车订单已有司机接单?如果一直没有司机接单怎么办?</div>
          <div className="answer-content">
            <p>A：由于取送车司机素质和能力要求高、人数有限、一般预约后1小时有司机接单，如果取送车订单已经有司机接单，可在"预约维保"界面中看到司机的联系方式，如有需要沟通可直接拨打司机电话进行沟通。如没有显示司机联系方式，则没有司机接单，可联系预约服务中心进行催促。</p>
          </div>
        </div>
      </div>
    </ModalInfo>
  );
}
